import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b77020e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "screen-bottom",
  id: "screen-bottom"
}
const _hoisted_2 = {
  class: "page-wrapper",
  id: "page"
}
const _hoisted_3 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopUpHandler = _resolveComponent("PopUpHandler")!
  const _component_ScreenOverlay = _resolveComponent("ScreenOverlay")!
  const _component_auth_init = _resolveComponent("auth-init")!
  const _component_settings_init = _resolveComponent("settings-init")!
  const _component_the_aside = _resolveComponent("the-aside")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PopUpHandler)
    ]),
    _createVNode(_component_ScreenOverlay),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_auth_init),
      _createVNode(_component_settings_init),
      _createVNode(_component_the_aside),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              name: "route",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}